export default __webpack_public_path__ + "static/media/job_offer10_s.c5241ee7.jpg";